<template>
  <div>
    <v-row dense no-gutters cols="12">      
      <v-col cols="5">
        <v-row dense>
          <v-col cols="12">
            <re_radioset :value="wizardData.margin_relative" field="margin_relative" @updateData="updateData"/>
          </v-col>  
        </v-row>                
        <div v-if="wizardData.margin_relative===true">
          <hsnp_wizard_step_02_margin_relative :wizardData="wizardData"  @updateData="updateData" class="ml-3"/>
        </div>
        <div v-else>
          <hsnp_wizard_step_02_margin_exact :wizardData="wizardData"  @updateData="updateData" class="ml-3"/>
        </div>
      </v-col>
      <v-col cols="6" class="mt-3">
        <weekdays :days="wizardData.margin_days" field="margin_days" color="primary" @updateData="updateData" class="ml-3"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-radio-group dense v-model="wizardData.margin_auto_update"  v-on:change="updateMarginAuto" class="mt-0 ml-3 mb-0">
          <v-radio key='0' label="Automatically recalculate sales price with the purchase price as a base (purchase price remains unchanged)" :value=0></v-radio>
          <v-checkbox v-if="wizardData.margin_auto_update===0"
            dense
            label="Automatically update week price using the relative change of the sales price" 
            v-model="wizardData.margin_weekprice_auto_update" 
            v-on:change="updateWeekPrice"
            class="mt-0 ml-10">
          </v-checkbox>          
          <v-radio key='1' label="Automatically recalculate purchase price with the sales price as a base (sales price remains unchanged)" :value=1></v-radio>
          <v-checkbox v-if="wizardData.margin_auto_update===1"
            dense
            label="Automatically update minimum purchase price using the relative change of the purchase price" 
            v-model="wizardData.margin_minpurchase_auto_update" 
            v-on:change="updateMinimumPurchasePrice"
            class="mt-0 ml-10">
          </v-checkbox>          
        </v-radio-group>
      </v-col>  
    </v-row>    
  </div>      
</template>

<script>
  import weekdays from '@/components/huis/hspt/ui/weekdays.vue';
  import re_radioset from '@/components/huis/hspt/ui/re_radioset.vue';
  import hsnp_wizard_step_02_margin_relative from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_margin_relative.vue';
  import hsnp_wizard_step_02_margin_exact from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_margin_exact.vue';  

  export default {
    props: {
      wizardData: Object
    },    
    components: {
      weekdays,
      re_radioset,
      hsnp_wizard_step_02_margin_relative,
      hsnp_wizard_step_02_margin_exact,      
    },
    methods:{
      updateMarginAuto(data){
        this.updateData({"field": "margin_auto_update", "value": data});
      },
      updateMinimumPurchasePrice(data){
        this.updateData({"field": "margin_minpurchase_auto_update", "value": data});
      },
      updateWeekPrice(data){
        this.updateData({"field": "margin_weekprice_auto_update", "value": data});
      },      
      updateData(data){
        this.$emit('updateData', data);      
      }      
    }
  }

</script>

<style scoped>
</style>